const USER_PERMISSIONS_STORE_KEY = 'user_permissions';

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const Storage = {
    storePermission(permissions) {
        return localStorage.setItem(USER_PERMISSIONS_STORE_KEY,JSON.stringify(permissions))
    },

    getPermissions() {
        return JSON.parse(localStorage.getItem(USER_PERMISSIONS_STORE_KEY) || '[]');
    },

    removeToken() {
        localStorage.removeItem(USER_PERMISSIONS_STORE_KEY)
    }
}

export default Storage;